import { render, staticRenderFns } from "./HomeArtwork.vue?vue&type=template&id=3fca5432&scoped=true&"
import script from "./HomeArtwork.vue?vue&type=script&lang=js&"
export * from "./HomeArtwork.vue?vue&type=script&lang=js&"
import style0 from "./HomeArtwork.vue?vue&type=style&index=0&id=3fca5432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fca5432",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VContainer,VFlex,VHover,VLayout})
